import {
	Menu,
	type MenuClickTriggerProps,
	type MenuRootProps,
	type MenuSelectGroupProps,
	type MenuVariantProps,
	Text,
} from "@overmap-ai/blocks"
import { memo, type ReactElement } from "react"

import { PROCEDURE_STEP_COMPLETION_MODES } from "../../constants"
import { AssetMapColorMode } from "../../enums/assets"
import { assetMapColorModeData } from "../../mappings/assets"
import { SelectItemTemplate } from "../MenuGroups/constants"

type AssetColorModeDropdownSelectProps = Omit<MenuRootProps, "children"> &
	Omit<MenuClickTriggerProps, "children"> &
	MenuVariantProps &
	MenuSelectGroupProps<AssetMapColorMode> & {
		children: ReactElement
	}

export const AssetColorModeDropdownSelect = memo<AssetColorModeDropdownSelectProps>((props) => {
	const {
		// Trigger props
		disabled = false,
		children,
		// MenuContent props
		radius,
		size,
		variant,
		accentColor,
		// MenuSelectGroupProps
		required,
		defaultValue,
		value,
		onValueChange,
		...rest
	} = props

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content size={size} radius={radius} accentColor={accentColor} variant={variant}>
				<Menu.Scroll>
					{/* @ts-expect-error REASON: destructure discriminate bug */}
					<Menu.SelectGroup<AssetMapColorMode>
						required={required}
						defaultValue={defaultValue}
						value={value}
						onValueChange={onValueChange}
					>
						<SelectItemTemplate<AssetMapColorMode> value={AssetMapColorMode.STATUS}>
							<div className="flex w-full min-w-0 flex-col">
								<span className="truncate">
									{assetMapColorModeData[AssetMapColorMode.STATUS].label}
								</span>
								<Text accentColor="base" weight="regular" size="sm">
									{assetMapColorModeData[AssetMapColorMode.STATUS].description}
								</Text>
							</div>
						</SelectItemTemplate>

						<Menu.Separator />

						<Menu.Label>Steps</Menu.Label>
						{PROCEDURE_STEP_COMPLETION_MODES.map((mode) => {
							const { label, description } = assetMapColorModeData[mode]

							return (
								<SelectItemTemplate<AssetMapColorMode> key={mode} value={mode}>
									<div className="flex w-full min-w-0 flex-col">
										<span className="truncate">{label}</span>
										<Text accentColor="base" weight="regular" size="sm">
											{description}
										</Text>
									</div>
								</SelectItemTemplate>
							)
						})}
					</Menu.SelectGroup>
				</Menu.Scroll>
			</Menu.Content>
		</Menu.Root>
	)
})
AssetColorModeDropdownSelect.displayName = "AssetColorModeDropdownSelect"
